var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade coupon-gift-modal",
      attrs: {
        id: _vm.modalId,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _vm.item
            ? _c(
                "div",
                { staticClass: "modal-content coupon-gift-modal__content" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "close coupon-gift-modal__close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Schließen",
                      },
                    },
                    [_vm._v("×")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body text-center" }, [
                    _c("span", { staticClass: "coupon-gift-modal__badge" }, [
                      _vm._v("Gratis-Geschenk"),
                    ]),
                    _vm._v(" "),
                    _vm.imageUrl
                      ? _c("div", { staticClass: "coupon-gift-modal__image" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.imageUrl,
                              alt: _vm.itemName,
                              loading: "lazy",
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h4", { staticClass: "coupon-gift-modal__title" }, [
                      _vm._v(_vm._s(_vm.itemName)),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "coupon-gift-modal__text",
                      domProps: { innerHTML: _vm._s(_vm.bodyText) },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary coupon-gift-modal__cta",
                        attrs: { disabled: _vm.isLoading || _vm.isInBasket },
                        on: { click: _vm.addToBasket },
                      },
                      [
                        _vm.isInBasket
                          ? _c("span", [_vm._v("Bereits im Warenkorb ✓")])
                          : _vm.isLoading
                          ? _c("span", [_vm._v("Wird hinzugefügt …")])
                          : _c("span", [_vm._v("Gratis in den Warenkorb")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link coupon-gift-modal__decline",
                        attrs: { type: "button", "data-dismiss": "modal" },
                      },
                      [_vm._v("Nein, danke")]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }